import fetch from '@/service/fetch';

export function getList(params) {
  return fetch('/api/portal/art/policy/page', {
    data: params
  })
}